import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

import './styles.scss'

const WithSubTextCellRenderer = ({
  value,
}: ICellRendererParams<unknown, { subText: string; text: string } | undefined>): ReactElement => {
  if (!value) return <div />

  const { subText, text } = value

  return (
    <div className="with-sub-text-cell-renderer text">
      <span className="with-sub-text-cell-renderer__text text">{text}</span>
      <span className="with-sub-text-cell-renderer__sub-text text">{subText}</span>
    </div>
  )
}

export default WithSubTextCellRenderer
